import {BasePlugin} from './BasePlugin';
import {CookieConsent} from '../CookieConsent';

/**
 * Enables the user to show the cookie dialog to update consent settings by clicking a link/button that matches the
 * given selector.
 */
export class CookieDialogTrigger extends BasePlugin {
    options = {
        triggerPopupSelector: '[href="#edit-cookies"]',
    };

    destroyController = new AbortController();

    constructor(options = {}) {
        super();

        this.options = {
            ...this.options,
            ...options,
        };
    }

    initialize(cookieConsent) {
        super.initialize(cookieConsent);
        document.addEventListener('click', e => this.onClick(e), {
            signal: this.destroyController.signal,
        });
    }

    destroy() {
        this.destroyController.abort();
    }

    onClick(e) {
        if (e.target.closest(this.options.triggerPopupSelector) === null) {
            return;
        }
        e.preventDefault();
        this.cookieConsent.toggleOptions(true);
        this.cookieConsent.show(CookieConsent.SOURCE_USER);
    }
}
